<template>
    <section class="notification-item">
        <section class="notification-item__icon">
            <img src="@/assets/icons/components/error-alert.svg" />
        </section>
        <section class="notification-item__body">
            <section class="notification-item__body__title">
                {{$t('com.file.invalid-invoice-email.title')}}
            </section>
            <section class="notification-item__body__description">
                {{$t('com.file.invalid-invoice-email.description')}}
            </section>
            <section class="notification-item--center">
                <button class="notification-item__button notification-item__button--small notification-item__button--white"
                        @click="openEditInvoiceData">
                    <span class="notification-item__button__text">{{$t('com.file.invalid-invoice-email.edit-data')}}</span>
                </button>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "InvalidInvoiceEmail",
        methods: {
            openEditInvoiceData() {
                this.$store.commit("setClientInvoiceBuyerModalStatus", true);
            },
        }
    }
</script>
<style lang="scss" scoped>
    @use '@/assets/scss/notification-item.scss';
</style>
